class AdsFreqCap {
  constructor() {
    const keyName = 'AdsFeqCap';
    const storageVersion = 'v1';
    this.data = null;
    this.storageName = keyName + '_' + storageVersion;
    // console.log("initiated AdsFreqCap Instance", this.storageName);
    const unParsedData = localStorage.getItem(this.storageName);
    if (unParsedData && unParsedData != '{}') {
      try {
        const parsedData = JSON.parse(unParsedData);
        this.data = parsedData;
      } catch (err) {
        console.log("Error parsing data");
        this.data = {}
      }
    } else {
      // Initialise the localStorage for AdsFreqCap
      console.log("init")
      const freqCapInit = { 'BANNER': {}, 'CAMPAIGN': {} };
      localStorage.setItem(this.storageName, JSON.stringify(freqCapInit));
    }
  }

  get(type, id) {
    let data = this.data;
    if (!data) {
      return null;
    }
    if (type && type in data) {
      data = data[type];
      if (id && id in data) {
        data = data[id];
      } else {
        return null;
      }
    }
    return data;
  }

  set(type, id, FCDetails) {
    // check if old data exists for given id
    // if already exists then update the FCDetail fields accordigly
    // else create new with default values and store it to according type
    // update this.data with latest data after update
    console.log("set", type, id, FCDetails, this.data);
    const existingData = { ...this.data };
    const data = existingData[type];
    try {
      if (id in data) {
        const element = { ...data[id], ...FCDetails };
        const isTimeElapsed = this.isTimeElapsedFc(element);
        if (isTimeElapsed) {
          element.firstImpressionTime = 0;
          element.impressionCounter = 0;
        }
        data[id] = { ...element, ...FCDetails };
      } else {
        console.log("creating new entry for the id ", id);
        data[id] = {
          type,
          id,
          impressionCounter: 0,
          cap: 0,
          resetTimer: -1,
          firstImpressionTime: 0,
          ...FCDetails
        }
      }
      localStorage.setItem(this.storageName, JSON.stringify(existingData));
      this.data = existingData;
    } catch (err) {
      console.log("Error setting feqCap Data", err);
    }
  }

  fcCleanup(fcObject) {
    const data = fcObject || this.data;
    const timeNow = Date.now();
    if (!data || Object.keys(data) == 0) {
      console.warn("Err: No data to clean frequency cap")
      return;
    }
    Object.keys(data).forEach(key1 => {
      if (!data[key1]) {
        return;
      }
      Object.keys(data[key1]).forEach(key2 => {
        const element = data[key1][key2];
        const firstImpression = element.firstImpressionTime;
        const isTimeElapsed = ((timeNow - firstImpression) / 1000) >= element.resetTimer;
        if ((firstImpression == 0) || ((firstImpression != 0) && (isTimeElapsed))) {
          // element.firstImpressionTime = 0;
          // element.impressionCounter = 0;
          // data[key1][key2] = element;
          const id = (key1 == 'BANNER') ? element.bannerId : element.campaignId;
          delete data[key1][id]; // delete the
          console.log(data)
        }
      });
    })
    console.log("key data", data);
    this.data = data;
    localStorage.setItem(this.storageName, JSON.stringify(data))
    return data;
  }

  isTimeElapsedFc = (element) => {
    const timeNow = new Date();
    const firstImpression = element.firstImpressionTime;
    const isTimeElapsed = ((timeNow - firstImpression) / 1000) >= element.resetTimer;
    return isTimeElapsed;
  }

  checkIfFcCapped = (ad) => {
    const campaignId = ad && ad.campaignId;
    const bannerId = ad && ad.bannerId;
    const fcCampaignCapData = this.get('CAMPAIGN', campaignId);
    const fcBannerCapData = this.get('BANNER', bannerId);
    return this.checkForFC(fcBannerCapData, fcCampaignCapData);
  }

  checkForFC = (fcBannerCapData, fcCampaignCapData) => {
    let adReachedFCCap = false;
    if (fcBannerCapData && fcBannerCapData.impressionCounter >= fcBannerCapData.cap) {
      adReachedFCCap = true;
    }
    // checking campaign each time for validity
    if (fcCampaignCapData && fcCampaignCapData.impressionCounter >= fcCampaignCapData.cap) {
      adReachedFCCap = true;
    }
    // console.log("Check for FC", adReachedFCCap)
    return adReachedFCCap;
  }

  getListFrequencyCapped = () => {
    const data = this.data;
    const fcap = {};
    if (!data || Object.keys(data) == 0) {
      return []
    }
    Object.keys(data).forEach(key1 => {
      if (!data[key1]) {
        return;
      }
      Object.keys(data[key1]).forEach(key2 => {
        const element = data[key1][key2];
        if (element.impressionCounter == element.cap) {
          // if(element.campaignId in fcap) {

          // } else {

          // }
          fcap[element.campaignId] = {
            "cap": element.cap,
            "resetTime": element.resetTime,
            "impressionCounter": {
              "actual": element.impressionCounter, //seen ads
              "softCounter": 0   //inserted but unseen ads
            },
            "firstImpressionTime": element.firstImpressionTime
          }
        }
      });
    })
    return fcap;
  }

  // Function Associated with getAds -> On new Ad if local entry had FC on Banner
  // or Camaign level then we need to clear if key missin in the Ad response
  clearFCIfClearedOnServer = (bannerId, campaignId, bImpFcap, impFcap) => {
    const data = this.data;
    if (bannerId in data['BANNER'] && !bImpFcap) {
      delete data['BANNER'][bannerId];
      localStorage.setItem(this.storageName, JSON.stringify(data));
    } else if (campaignId in data['CAMPAIGN'] && !impFcap) {
      delete data['CAMPAIGN'][campaignId];
      localStorage.setItem(this.storageName, JSON.stringify(data))
    }
  }
}

export default AdsFreqCap;